  <ng-container *ngIf="components$ | async as components">
    <ng-container *ngFor="let component of components; let i = index">
      <ng-container *ngIf="component && getIndexOfTab(component.uid) | async as index">
        <button class="mb-pdp-tab-title"
                [style]="{'grid-column': index}"
                [class.active]="i === activeTabNum"
                [attr.data-cy]="'mb-pdp-tab-title-' + component.title?.toLowerCase()"
                (click)="select(i, $event)">
          {{component.title}}
        </button>
        <ng-container *ngIf="isScreenForSmallDevices() | async">
          <div *ngIf="getTotalNumberOfTabs() | async as tabsNo"
               class="mb-pdp-tab-content-wrapper"
               [style]="{'grid-column': '1 / span ' + tabsNo}"
               [class.active]="i === activeTabNum"
               [attr.data-cy]="'mb-pdp-tab-content-' + component.title?.toLowerCase()">
            <ng-template [cxOutlet]="component.flexType" [cxOutletContext]="{}">
              <ng-container [cxComponentWrapper]="component"></ng-container>
            </ng-template>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!(isScreenForSmallDevices() | async)">
      <ng-container *ngFor="let component of components; let i = index">
        <ng-container *ngIf="component">
          <div *ngIf="getTotalNumberOfTabs() | async as tabsNo"
               class="mb-pdp-tab-content-wrapper"
               [style]="{'grid-column': '1 / span ' + tabsNo}"
               [class.active]="i === activeTabNum"
               [attr.data-cy]="'mb-pdp-tab-content-' + component.title?.toLowerCase()">
            <ng-template [cxOutlet]="component.flexType" [cxOutletContext]="{}">
              <ng-container [cxComponentWrapper]="component"></ng-container>
            </ng-template>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
